<template>
  <div v-loading="loadingMod">
    <Title title="Edita tu Planificación"
           subtitle="Edita las rutas de tu planificación seleccionando puntos"/>
    <SectorList v-if="sectors.length > 0"
                :sectors="sectors"/>
    <div class="rowRoutePatent">
      <i class="el-icon-view header-icon"/>
      <span class="titleStyle">Seguimiento Nº {{ idTracing }}</span>
      <i class="el-icon-position header-icon"/>
      <span class="titleStyle">Rutas: {{ routesList | count }}</span>
      <el-button type="text" class="return" @click="returnMod()">
        <i class="el-icon-arrow-left"/>VOLVER
      </el-button>
    </div>
    <div class="content">
      <el-row :gutter=5>
        <el-col :span="9">
          <Routes v-model="routesList"
                  :sectors="sectors"
                  :loadingRoutes="loadingRoutes"
                  :selectedMarkId="selectedMarkId"
                  :routesSelectAll="routesSelectAll"
                  @reload="reload"
                  @getUpload="getUpload"
                  @selectedAllPoint="selectedAllPoint"
                  @getSelected="getSelected"
                  @dialog-edit="editRoute"
                  @dialog-change-plate="editPlate"
                  @lauch-replanning="replanningLaunchHandler"/>
        </el-col>
        <el-col :span="15">
          <el-col :span="13">
            <MultiRouteMap
              ref="mapWrapper"
              :routes="routesToMap"
              :selectedRoutes="routesSelected"
              v-model="movingSocs"/>
          </el-col>
          <el-col :span="11">
            <Selected
              v-model="movingSocs"
              :vehicles="vehicles"
              @reload="reload"
              @geoAction="debug"
              @moveToRoute="moveToHandler"/>
          </el-col>
        </el-col>
      </el-row>
    </div>
    <dialog-change ref="TimAddRem"
                   @tim="timHandler"
                   @add="addSocsHandler"
                   @del="remSocsHandler"
                   @addLpn="addLpnHandler"
                   @deleteLpn="deleteLpnHandler"
                  />
    <dialog-change-confirm ref="changeConfirm"
                         @confirm="confirmHandler"/>
    <dialog-change-summary ref="summary"/>
    <dialog-change-plate ref="editPlate"
                         @getDatatracing="getDatatracing"/>
  </div>
</template>

<script>
import { throws } from 'assert';
import { getRumDuration, startRumTiming, trackBusinessFlow } from '@/observability/datadogRum';
import Routes from '../components/routesV2/routes.vue';
import Title from '../components/base/Title.vue';
import Selected from '../components/routesV2/selected.vue';
import MultiRouteMap from '../components/routesV2/MultiRouteMap.vue';
import { apiRequest } from '../../backend/vue-axios/axios';
import { TaskQueue } from '../../mixins/taskQueue';
import DialogChange from '../components/routesV2/DialogChange.vue';
import DialogChangeConfirm from '../components/routesV2/DialogChangeConfirm.vue';
import DialogChangeSummary from '../components/routesV2/DialogChangeSummary.vue';
import DialogChangePlate from '../components/routesV2/DialogChangePlate.vue';
import SectorList from '../components/routesV2/sector/List.vue';

export default {
  props: {
    idRoute: {
      type: Number,
      default: 0,
    },
    idTracing: {
      type: String,
      default: '',
    },
  },
  name: 'PlanningEditRoutesV2',
  components: {
    Title,
    Routes,
    Selected,
    SectorList,
    MultiRouteMap,
    DialogChange,
    DialogChangeConfirm,
    DialogChangeSummary,
    DialogChangePlate,
  },
  data() {
    return {
      routesSelectAll: [],
      routesList: [],
      routesData: [],
      routes: [],
      routesSelected: [],
      watcherInterval: 0,
      loadingMod: false,
      loadingRoutes: true,
      activeRoutes: true,
      selectedMarkId: [],
      messageRoutesActives: 0,
      taskQueue: new TaskQueue(100),
      movingSocs: [],
      dialogEditSoc: false,
      resultMod: false,
      dialog: {
        checkOrder: false,
      },
      idRouteModSoc: '',
      vehicle: '',
    };
  },
  filters: {
    count(data) {
      return data.length;
    },
  },
  beforeDestroy() {
    clearInterval(this.watcherInterval);
  },
  mounted() {
    this.getRoutesId().then((ids) => {
      this.getDatatracing(ids);
    }).catch((e) => {
      console.error('err', e);
    });
    this.getTracing();
    this.watcherInterval = setInterval(() => {
      if (this.routesRStateWatchList.length > 0) {
        apiRequest({
          module: 'planning',
          service: 'replanning_status',
          params: { route_ids: this.routesRStateWatchList },
        }).then((res) => {
          if (res.data.status) {
            const refreshableRoutes = [];
            res.data.status.forEach((repSt) => {
              const route = this.routesList.find(r => r.id === repSt.route_id);
              if (route.replanning_state !== repSt.replanning_state) {
                route.replanning_state = repSt.replanning_state;
                if (repSt.replanning_state === 0) {
                  route.modified = false;
                  refreshableRoutes.push(repSt.route_id);
                } else if (repSt.replanning_state === -1) {
                  route.modified = true;
                  refreshableRoutes.push(repSt.route_id);
                  this.$notify({
                    type: 'error',
                    title: 'Error',
                    message: 'Ha ocurrido un error en la replanificación. Vuelva a intentarlo.',
                  });
                }
              }
            });
            if (refreshableRoutes.length > 0) {
              this.getDatatracing(refreshableRoutes);
            }
          }
        }).catch((err) => {
          console.error(err);
          clearInterval(this.watcherInterval);
        });
      }
    }, 10000);
  },
  watch: {
    movingSocs(socs) {
      this.routesSelectAll = this.routes
        .filter(r => r.soc === socs.filter(s => s.routes_id === r.id).length)
        .map(r => r.id);
    },
  },
  methods: {
    editRoute(routeId) {
      const theRoute = this.routesData.find(r => r.id === routeId);
      this.$refs.TimAddRem.showChangeDialog(theRoute);
      this.dialogEditSoc = true;
    },
    editPlate(routeId, plate) {
      this.$refs.editPlate.showChangeDialog(routeId, plate);
    },
    timHandler(routeId, tim) {
      const theRoute = this.routesData.find(r => r.id === routeId);
      const socList = theRoute.delivery_points.map(dp => dp.code);
      const toDelete = socList.filter(soc => !tim.includes(soc));
      const toAdd = tim.filter(soc => !socList.includes(soc));
      this.$refs.changeConfirm.showConfirmDialog(routeId, toAdd, toDelete, [], []);
    },
    addSocsHandler(routeId, toAdd) {
      this.$refs.changeConfirm.showConfirmDialog(routeId, toAdd, [], [], []);
    },
    remSocsHandler(routeId, toDelete) {
      this.$refs.changeConfirm.showConfirmDialog(routeId, [], toDelete, [], []);
    },
    addLpnHandler(routeId, lpnsToAdd) {
      this.$refs.changeConfirm.showConfirmDialog(routeId, [], [], lpnsToAdd, []);
    },
    deleteLpnHandler(routeId, lpnsToDelete) {
      this.$refs.changeConfirm.showConfirmDialog(routeId, [], [], [], lpnsToDelete);
    },
    confirmHandler(routeId, socsToAdd, socsToRemove, lpnsToAdd, lpnsToDelete) {
      const safeSocsToAdd = Array.isArray(socsToAdd) ? socsToAdd : [];
      const safeSocsToRemove = Array.isArray(socsToRemove) ? socsToRemove : [];
      const safeLpnsToAdd = Array.isArray(lpnsToAdd) ? lpnsToAdd : [];
      const safeLpnsToDelete = Array.isArray(lpnsToDelete) ? lpnsToDelete : [];

      this.addDeleteFromRoute(
        routeId,
        safeSocsToAdd,
        safeSocsToRemove,
        safeLpnsToAdd,
        safeLpnsToDelete,
      );
    },
    setRoutesAsLoading(routes) {
      routes.forEach((rId) => {
        this.routesList.find(r => r.id === rId).loadData = false;
      });
    },
    setRoutesAsLoaded(routes) {
      routes.forEach((rId) => {
        this.routesList.find(r => r.id === rId).loadData = true;
      });
    },
    addDeleteFromRoute(routeId, socsToAdd, socsToRemove, lpnsToAdd, lpnsToDelete) {
      const safeSocsToAdd = Array.isArray(socsToAdd) ? socsToAdd : [];
      const safeSocsToRemove = Array.isArray(socsToRemove) ? socsToRemove : [];
      const safeLpnsToAdd = Array.isArray(lpnsToAdd) ? lpnsToAdd : [];
      const safeLpnsToDelete = Array.isArray(lpnsToDelete) ? lpnsToDelete : [];
      const paramStruct = {
        add_suborders: safeSocsToAdd,
        remove_suborders: safeSocsToRemove,
        add_lpn: safeLpnsToAdd,
        remove_lpn: safeLpnsToDelete,
      };
      const startedAt = startRumTiming();
      trackBusinessFlow({
        module: 'planning',
        flow: 'route_editing_v2',
        action: 'route_update_requested',
        status: 'attempt',
        context: {
          tracing_id: this.idTracing,
          route_id: routeId,
          add_suborders: safeSocsToAdd.length,
          remove_suborders: safeSocsToRemove.length,
          add_lpn: safeLpnsToAdd.length,
          remove_lpn: safeLpnsToDelete.length,
        },
      });
      apiRequest({
        module: 'planning',
        service: 'addanddelete_suborders',
        pathparam: { id: routeId },
        params: paramStruct,
      }).then((res) => {
        let modifiedRoutes = [];
        if (res.data.add_success && res.data.add_success.length > 0) {
          modifiedRoutes = this.routesData
            .filter(r => r.delivery_points.map(dp => dp.code)
              .some(soc => res.data.add_success.includes(soc)))
            .map(r => r.id);
        }

        if (res.data.add_lpn_success && res.data.add_lpn_success.length > 0) {
          modifiedRoutes = this.routesData
            .filter(r => r.delivery_points.map(dp => dp.code)
              .some(soc => res.data.add_lpn_success.includes(soc)))
            .map(r => r.id);
        }

        modifiedRoutes.push(routeId);
        modifiedRoutes = [...(new Set(modifiedRoutes))];
        this.setRoutesAsLoading(modifiedRoutes);
        this.$refs.summary.showSummary(res.data);
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_editing_v2',
          action: 'route_update_completed',
          status: 'success',
          durationMs: getRumDuration(startedAt),
          context: {
            tracing_id: this.idTracing,
            route_id: routeId,
            modified_routes: modifiedRoutes.length,
            add_success: res.data.add_success ? res.data.add_success.length : 0,
            remove_success: res.data.remove_success ? res.data.remove_success.length : 0,
            add_lpn_success: res.data.add_lpn_success ? res.data.add_lpn_success.length : 0,
            remove_lpn_success: res.data.remove_lpn_success ? res.data.remove_lpn_success.length : 0,
          },
        });
        this.getDatatracing(modifiedRoutes);
      }).catch((error) => {
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_editing_v2',
          action: 'route_update_completed',
          status: 'error',
          durationMs: getRumDuration(startedAt),
          context: {
            tracing_id: this.idTracing,
            route_id: routeId,
            error_status: error.response ? error.response.status : null,
          },
        });
        if (error.response) {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: error.response.data.message,
          });
        }
        // this.property.vehicle.patent = this.oldValue;
        this.loading = false;
      });
    },
    moveToHandler(routeId, toAdd) {
      this.$refs.changeConfirm.showConfirmDialog(routeId, toAdd, [], [], []);
    },
    replanningLaunchHandler(routeId) {
      this.$confirm('¿Estas seguro que quieres replanificar tu ruta?', 'Confirma tu Replanificación', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(() => {
        const startedAt = startRumTiming();
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_replanning_v2',
          action: 'replanning_requested',
          status: 'attempt',
          context: {
            tracing_id: this.idTracing,
            route_id: routeId,
          },
        });
        const messageReplanning = this.$message({
          message: `Replanificando Ruta ${routeId}, espera un momento por favor`,
          showClose: true,
          duration: 0,
        });
        apiRequest({
          module: 'planning',
          service: 'replanning_route',
          pathparam: { id: routeId },
          params: { id: routeId },
        }).then((res) => {
          this.$notify({
            type: 'success',
            title: 'REPLANIFICACIÓN ACEPTADA',
            message: `Ruta Nº ${res.data.id} en espera...`,
          });
          trackBusinessFlow({
            module: 'planning',
            flow: 'route_replanning_v2',
            action: 'replanning_completed',
            status: 'success',
            durationMs: getRumDuration(startedAt),
            context: {
              tracing_id: this.idTracing,
              route_id: routeId,
            },
          });
          this.routesList.find(r => r.id === routeId).replanning_state = 1;
          messageReplanning.close();
        }).catch((error) => {
          trackBusinessFlow({
            module: 'planning',
            flow: 'route_replanning_v2',
            action: 'replanning_completed',
            status: error.response && error.response.status === 504 ? 'timeout' : 'error',
            durationMs: getRumDuration(startedAt),
            context: {
              tracing_id: this.idTracing,
              route_id: routeId,
              error_status: error.response ? error.response.status : null,
            },
          });
          if (error.response !== undefined) {
            if (error.response.status === 504) {
              this.$notify({
                type: 'warning',
                showClose: true,
                title: 'INFO',
                message: 'Revisa el Seguimiento de procesos background ingresando a INFO COD:504',
              });
              messageReplanning.close();
            } else {
              if (error.response.status > 400 && error.response.status < 500) {
                this.$notify({
                  type: 'warning',
                  title: 'Planificación en proceso',
                  showClose: true,
                  message: error.response.data.message,
                });
              } else {
                this.$notify({
                  type: 'error',
                  title: 'Error',
                  showClose: true,
                  message: error.response.data.message,
                });
              }
              messageReplanning.close();
            }
          } else {
            messageReplanning.close();
          }
        });
      }).catch(() => {
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_replanning_v2',
          action: 'replanning_cancelled',
          status: 'cancelled',
          context: {
            tracing_id: this.idTracing,
            route_id: routeId,
          },
        });
      });
    },
    returnMod() {
      if ([1, 2, 3].includes(this.$route.params.v)) {
        const querys = {};
        const parameter = {};
        if (this.$route.params.v === 1) {
          querys.distribution_centers_id = this.$route.params.distribution_centers_id;
          parameter.v = 1;
        }
        if (this.$route.params.v === 2) {
          querys.enterprise_id = this.$route.params.enterprise_id;
          parameter.v = 2;
        }
        if (this.$route.params.v === 3) {
          querys.enterprise_id = this.$route.params.enterprise_id;
          querys.distribution_centers_id = this.$route.params.distribution_centers_id;
          parameter.v = 3;
        }
        this.$router.push({
          name: 'Status',
          query: querys,
          params: parameter,
        });
      } else if (this.$route.params.v === 4) {
        this.$router.push({
          name: 'modify',
        });
      } else {
        this.$router.push({
          name: 'Status',
          params: { v: 0 },
        });
      }
    },
    checkOrders() {
    },
    closeDialogTabs() {
    },
    cancelModSoc() {
    },
    addOrderSoc() {
    },
    tabClick() {
    },
    reload() {
      this.routesList = [];
      this.getTracing();
    },
    getUpload(socs, idsToUpdate) {
      socs.forEach((soc) => {
        this.routesData.filter(r => r.delivery_points.map(dp => dp.code).includes(soc))
          .forEach((el) => {
            idsToUpdate.push(el.id);
          });
      });
      if (idsToUpdate.length > 0) {
        idsToUpdate
          .forEach((id) => { this.routesList.find(r => r.id === id).loadData = false; });
        this.getDatatracing(idsToUpdate);
      }
    },
    selectedAllPoint(id) {
      this.$refs.mapWrapper.selectRoute(id);
    },
    getSelected(data) {
      this.routes = data;
    },
    getRoutesId() {
      return new Promise((resolve, cancel) => {
        apiRequest({
          module: 'planning',
          service: 'get_routes_id',
          pathparam: { id: this.idTracing },
        }).then((response) => {
          resolve(response.data);
        }).catch((e) => {
          this.$message.error('Hubo un error al obtener las rutas');
          cancel(e);
        });
      });
    },
    getTracing() {
      this.loadingRoutes = true;
      const startedAt = startRumTiming();
      apiRequest({
        module: 'planning',
        service: 'get_routes_multiple_v2',
        pathparam: { id: this.idTracing },
      }).then((response) => {
        if (response.data.length === 0) {
          this.$message.warning('No se encontró ninguna ruta');
        } else {
          this.taskQueue.enqueue().then(() => {
            this.routesList = response.data
            // eslint-disable-next-line max-len
              .map(r => Object.assign(r, { loadData: this.routesData.map(rd => rd.id).includes(r.id) }))
              .sort((a, b) => a.id - b.id);
            this.messageRoutesActives = this.routes.filter(r => r.active === true).length;
            if (this.messageRoutesActives === 1 && this.activeRoutes) {
              this.activeRoutes = false;
              this.$message({
                type: 'warning',
                message: 'La planificación tiene rutas activas que no pueden ser modificadas.',
              });
            }
          });
        }
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_editing_v2',
          action: 'routes_loaded',
          status: response.data.length === 0 ? 'empty' : 'success',
          durationMs: getRumDuration(startedAt),
          context: {
            tracing_id: this.idTracing,
            routes_count: response.data.length,
          },
        });
        this.loadingRoutes = false;
      }).catch(() => {
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_editing_v2',
          action: 'routes_loaded',
          status: 'error',
          durationMs: getRumDuration(startedAt),
          context: {
            tracing_id: this.idTracing,
          },
        });
        this.$message.error('Hubo un error al obtener las rutas');
        this.loadingRoutes = false;
      });
    },
    getDatatracing(ids) {
      if (ids) {
        const newArr = [];
        while (ids.length) newArr.push(ids.splice(0, 10));
        newArr.forEach((slice) => {
          apiRequest({
            module: 'planning',
            service: 'get_routes_soc_info',
            pathparam: { ids: slice },
          }).then((response) => {
            const self = this;
            this.taskQueue.enqueue().then(() => {
              // TODO: verificar si cargo completa la 2ª query. posibles inconsistencias.
              let mustReloadMap = false;
              response.data.forEach((resp) => {
                const tableRow = self.routesList.find(r => r.id === resp.id);
                if (self.routesData.filter(r => r.id === resp.id).length > 0) {
                  if (resp.vehicle) {
                    tableRow.KM = '';
                    tableRow.plate = resp.vehicle.plate;
                    tableRow.volume = Math.round((resp.delivery_points
                      .reduce((acum, el) => acum + el.total_volumen, 0) / resp.vehicle.capacity)
                      * 100);
                  } else tableRow.volume = '-';
                  tableRow.soc = resp.delivery_points.length;
                  Object.assign(self.routesData.find(r => r.id === resp.id), resp);
                  if (self.routes.map(sr => sr.id).includes(resp.id)) {
                    mustReloadMap = true;
                  }
                } else {
                  self.routesData.push(resp);
                }

                if (tableRow) {
                  tableRow.loadData = true;
                }
              });
              if (mustReloadMap) {
                this.$refs.mapWrapper.reRenderMap();
              }
            });
          }).catch(() => {
            this.$message.error('Hubo un error al obtener las rutas');
          });
        });
      }
    },
    debug(arg1, arg2, arg3) {
      console.error(arg1, arg2, arg3);
    },
  },
  computed: {
    sectors() {
      return this.routesList
        .map(route => ({
          id: route.sector_id,
          color: route.sector_color,
          name: route.sector_name,
          active: true,
        }))
        .filter((s, i, acum) => s.id && acum.findIndex(el => el.id === s.id) === i)
        .sort((a, b) => (b.id > a.id ? -1 : 1));
    },
    routesRStateWatchList() {
      return this.routesList.filter(r => r.replanning_state > 0 && r.modified).map(r => r.id);
    },
    routesToMap() {
      return this.routesData.filter(r => this.routes.map(sr => sr.id).includes(r.id));
    },
    vehicles() {
      return this.routesData.filter(r => r.vehicle)
        // eslint-disable-next-line array-callback-return
        .map(r => Object.assign(JSON.parse(JSON.stringify(r.vehicle)), {
          route_id: r.id,
          volume_rate: r.delivery_points
            .reduce((acc, dp) => acc + dp.total_volumen, 0) / r.vehicle.capacity,
        })).sort((a, b) => (b.plate > a.plate ? -1 : 1));
    },
  },
};
</script>

<style lang="scss" scoped>
  .rowRoutePatent{
    display: table;
    height: 20px;
    margin-bottom: 0;
    text-align: left;
  }
  .titleStyle {
    font-size: 11px;
    color: #707070;
    text-transform: uppercase;
    margin: 0 30px 0 0;
    font-weight: normal;
  }
  .header-icon {
    font-size: 11px;
    margin-right: 5px;
    color: #AAD500;
  }
  .return {
    padding: 0;
    font-size: 11px;
  }
.content {
  margin: 10px 0 50px 0;
}
</style>
